var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VMSSelect',{attrs:{"id":_vm.id,"items":_vm.KitItemWrappers,"label":_vm.label,"disabled":_vm.disabled,"rules":_vm.rules,"hint":_vm.hint,"placeholder":_vm.placeholder},on:{"input":_vm.onInput},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }